import styled from 'styled-components';
import { ButtonTag } from '../Button/styles';

export const CardTag = styled.article`
  position: relative;
  
  display: flex;
  align-items: flex-end;
  height: 100%;
  padding: 30px 25px;
  padding-bottom: 25px;
  
  border-radius: 6px;
  overflow: hidden;
  background-color: ${({theme}) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  
  @media(min-width: 700px) {
    padding: 50px 20px 35px 40px;
  }
`;

export const CardImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  
  pointer-events: none;
  
  img {
    width: 250px;
    margin-right: -10px;
  }
  
  @media(min-width: 700px) {
    img {
      width: 330px;
      margin-right: -50px;
    }
  }
  
  @media(min-width: 1024px) {
    img {
      width: 440px;
      margin-right: -30px;
    }
  }
`;

export const CardContainer = styled.div`
  position: relative;
  z-index: 1;
  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%; 
  
  color: ${({ theme }) => theme.black};
`;

export const CardHeading = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 36px;
  line-height: 50px;
  
  @media(min-width: 700px) {
    font-size: 49px;
    line-height: 61px;
  }
  
  @media(min-width: 1024px) {
    font-size: 68px;
    line-height: 78px;
  }
`;

export const CardSubheading = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: ${({ theme }) => theme.blue};
  
  @media(min-width: 700px) {
    margin-bottom: 5px;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
  }
`;

export const CardPrice = styled(ButtonTag)`
  margin-top: auto;
  padding-left: 28px;
  padding-right: 28px;
  
  font-weight: 700;
  font-size: 13px;
  
  span {
    font-size: 16px;
  }
`;
